<template>
  <div class="map-controls-container" :style="{height:!!containerHeight?containerHeight+'px':'600px'}">
    <div class="tmp-btns">
      <div class="mt-10">
        <button class="mr-10" @click="showOSSvg()">显示SVG</button>
        <button class="mr-10" @click="hideOSSvg()">隐藏SVG</button>
        <button class="mr-10" @click="showTempSvgFromCanvas()">SVG显示甲板设置Canvas</button>
        <button class="mr-10" @click="showOSSvgLineAnimation()">SVG路径动画开始</button>
        <button class="mr-10" @click="hideOSSvgLineAnimation()">SVG路径动画关闭</button>
      </div>
      <div class="mt-10">
        <button @click="showSetBaseStation($event)" class="mr-10">设置基站位置（包括到走廊路线）</button>
        <button class="mr-10" @click="hideSetBaseStation()">隐藏设置基站位置</button>
        <button class="mr-10" @click="showDrawArea()">画区域</button>
        <button class="mr-10" @click="hideDrawArea()">隐藏画区域</button>
      </div>
    </div>
    <div class="map-info">
      <span class="mr-15">缩放比例：{{scale}}</span>
      <span class="mr-15">X轴座标：{{Math.round(shipImage.left / scale)}}</span>
      <span class="mr-15">Y轴座标：{{Math.round(shipImage.top / scale)}}</span>
    </div>
    <div class="controls">
      <div class="item" title="放大" @click="setScaleAdd">
        <span class="zsf-icon zsf-icon-fangda"></span>
      </div>
      <div class="item" title="缩小" @click="setScaleCut">
        <span class="zsf-icon zsf-icon-suoxiao"></span>
      </div>
      <div class="item" title="移动">
        <span class="zsf-icon zsf-icon-mobile"></span>
      </div>
    </div>
    <div class="map-box" :style="{height:!!containerHeight?containerHeight+'px':'600px'}" id="map">
      <div class="set-deck-canvas" v-if="dsCanvasIsShow"
           :style="{width:containerInfo.width+'px',heigith:containerInfo.height+'px'}">
        <canvas id="set-deck-canvas"
                :style="{width:containerInfo.width+'px',heigith:containerInfo.height+'px'}"></canvas>
      </div>
      <div class="ship-img" :class="!movingFlag?'tran-all':''" id="moveDiv"
           :style="{ background:'white url('+shipImage.url+') no-repeat',width:shipImage.width+'px',height:shipImage.height+'px',transform:'scale('+scale+')',left:shipImage.left+'px',top:shipImage.top+'px'}">
        <div class="only-show-svg tran-all" v-if="osSvgIsShow"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
          <v-svg-polygon :svgPolygonPoints="svgPolygonPoints"></v-svg-polygon>
        </div>
        <div class="svg-line-animation-box" v-if="svgLineIsShow"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
          <v-svg-line ref="svgline" :scale="scale"></v-svg-line>
        </div>
        <div @click="setBaseStation" class="set-base-station-box"
             v-if="setBaseStationIsShow"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
              <span :style="{left:item.x+'px',top:item.y+'px',transform:'scale('+(1/scale)+')'}"
                    v-for="(item,index) in setBaseStationPoints"
                    :key="index"></span>
          <svg width="100%" height="100%" version="1.1">
            <line v-for="(item,index) in setBaseStationLigaturePoints"
                  :key="index" :x1="item.x1" :y1="item.y1"
                  :x2="item.x2" :y2="item.y2" style="stroke:red;stroke-width:2"></line>
          </svg>
        </div>
        <div class="draw-area-box" v-if="drawAreaIsShow"
             @click="drawArea"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
                 <span :style="{left:item.x+'px',top:item.y+'px',transform:'scale('+(1/scale)+')'}"
                       v-for="(item,index) in drawAreaPoints"
                       :key="index"></span>
          <svg width="100%" height="100%" version="1.1">
            <polygon :points="drawAreaPolygon"
                     style="fill:rgba(255,0,0,0.1);stroke:#ff0000;stroke-width:2"></polygon>
          </svg>
        </div>
        <div class="draw-point-box" v-if="drawOnePointIsShow"
             @click="drawOnePoint"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
          <span v-if="onePoint.x>0"
                :style="{left:onePoint.x+'px',top:onePoint.y+'px',transform:'scale('+(1/scale)+')'}"></span>
        </div>
      </div>
    </div>

    <el-dialog title="设置区域" :visible.sync="drawAreaDialogIsShow"
               :modal="false" width="600px">
      <div slot="footer" class="dialog-footer">
        <el-button-group class="mr-10">
          <el-button size="mini" type="primary" @click="drawAreaEsc">重新设置</el-button>
          <el-button size="mini" type="primary" @click="drawAreaComeOn">继续添加座标点</el-button>
          <el-button size="mini" type="primary" @click="drawAreaSubmit">确定</el-button>
        </el-button-group>
      </div>
    </el-dialog>

    <el-dialog title="设置座标点" :visible.sync="drawOnePointDialogIsShow"
               :modal="false" width="600px">
      <div slot="footer" class="dialog-footer">
        <el-button-group class="mr-10">
          <el-button size="mini" type="primary" @click="drawOnePointDialogIsShow">重新设置</el-button>
          <el-button size="mini" type="primary" @click="drawAreaSubmit">确定</el-button>
        </el-button-group>
      </div>
    </el-dialog>

    <el-dialog :modal="false" title="设置基站"
               :visible.sync="setBaseStationDialogIsShow" width="600px">
      <span>设置基站的座标点和该基站到走廊的路线</span>
      <div slot="footer" class="dialog-footer">
        <el-button-group class="mr-10">
          <el-button size="mini" type="primary"
                     @click="setBaseStationPointEsc">重新设置
          </el-button>
          <el-button size="mini" type="primary"
                     @click="setBaseStationPointComeOn">继续添加
          </el-button>
          <el-button size="mini" type="primary"
                     @click="setBaseStationPointSubmit">确定
          </el-button>
        </el-button-group>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from '../common/js/tool.js';
  export default{
    data(){
      return {
        shipImage: {
          url: '',
          width: 0,
          height: 0,
          left: 0,
          top: 0,
        },
        distanceX: 0,
        distanceY: 0,
        containerInfo: {
          width: 0,
          height: 0
        },
        scale: 1,
        widthScale: 1,
        heightScale: 1,
        scaleStep: 0.05,
        movingFlag: false,
        dsCanvasIsShow: false,
        dsCanvasObj: {
          origin: '',
          originForSet: [0, 0, 0, 0],
          width2height: '',
          canvas: '',
          ctx: '',
          canDraw: true
        },
        osSvgIsShow: false,
        osCanvasObj: {
          canvas: '',
          ctx: ''
        },
        svgPolygonPoints: [
          {name: '甲板1', points: [{x: 10, y: 10}, {x: 250, y: 10}, {x: 210, y: 210}, {x: 10, y: 210}]},
          {name: '甲板2', points: [{x: 310, y: 310}, {x: 850, y: 410}, {x: 510, y: 510}, {x: 310, y: 510}]},
          {name: '甲板3', points: [{x: 810, y: 810}, {x: 1050, y: 810}, {x: 1010, y: 1010}, {x: 810, y: 1010}]}
        ],
        svgLineIsShow: false,
        setBaseStationIsShow: false,
        setBaseStationPoints: [],
        setBaseStationLigaturePoints: [],
        setBaseStationTempPoint: '',
        setBaseStationDialogIsShow: false,
        drawAreaIsShow: false,
        drawAreaPoints: [],
        drawAreaPolygon: '',
        drawAreaDialogIsShow: false,
        drawOnePointIsShow: false,
        drawOnePointDialogIsShow: false,
        onePoint: {x: 0, y: 0},
      }
    },

    props: ['containerHeight', 'ship_img', 'shipMapData'],

    computed: {},

    created(){
      console.log(this.shipMapData);
    },

    mounted(){
      this.getShipImage();
      this.getMapSize();
      setTimeout(() => {
        this.setImageBecoming();
        this.monitorMove();
      }, 10);
      window.onresize = () => {
        this.getShipImage();
        this.getMapSize();
      };
    },

    methods: {
      test(){
        alert('test');
      },

      load(){
        this.dsCanvasIsShow = false;
        this.osSvgIsShow = false;
        this.svgLineIsShow = false;
        this.setBaseStationIsShow = false;
        this.setBaseStationDialogIsShow = false;
        this.drawAreaIsShow = false;
        this.drawAreaDialogIsShow = false;
        this.drawAreaPolygon = '';
        this.drawAreaPoints = [];
        this.setBaseStationPoints = [];
        this.setBaseStationLigaturePoints = [];
        let shipMapData = this.shipMapData;
        console.log(shipMapData);
        switch (shipMapData.type) {
          case 'setArea':
            this.drawAreaPoints = shipMapData.data.points;
            this.drawAreaIsShow = true;
            this.drawArea2();
            break;
          case 'setOnePoint':
            this.drawOnePointIsShow = true;
            this.onePoint.x = this.shipMapData.data.point.x;
            this.onePoint.y = this.shipMapData.data.point.y;
            console.log(this.onePoint);
            this.$emit('transmit', {
              id: this.shipMapData.data.id,
              points: this.onePoint,
              direction: this.shipMapData.data.direction,
              isPoint1: this.shipMapData.data.isPoint1
            });
            break;
          case 'setBaseStation':
            console.log(this.shipMapData);
            this.setBaseStationIsShow = true;
            this.setBaseStationPoints = this.shipMapData.data.points[0].x === 0 ? [] : this.shipMapData.data.points;
            this.setBaseStation2();
            break;
        }
      },

      emptyData(){
        this.setBaseStationPointEsc();
        this.drawAreaPoints = [];
        this.setBaseStationPoints = [];
        this.setBaseStationLigaturePoints = [];
      },

      drawAreaEsc(){
        this.drawAreaDialogIsShow = false;
        this.drawAreaPolygon = '';
        this.drawAreaPoints = [];
      },

      drawAreaComeOn(){
        this.drawAreaDialogIsShow = false;
      },

      drawAreaSubmit(){
        this.drawAreaDialogIsShow = false;
        this.$emit('transmit', {id: this.shipMapData.data.id, points: this.drawAreaPoints});
      },

      showDrawArea(){
        this.drawAreaIsShow = true;
      },

      hideDrawArea(){
        this.drawAreaIsShow = false;
      },

      drawOnePoint(e){
        this.$confirm("设置为此点的座标吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.onePoint.x = e.offsetX;
          this.onePoint.y = e.offsetY;
          console.log(this.onePoint);
          this.$emit('transmit', {
            id: this.shipMapData.data.id,
            points: this.onePoint,
            direction: this.shipMapData.data.direction,
            isPoint1: this.shipMapData.data.isPoint1
          });
        });
      },

      drawOnePointEsc(){
        this.onePoint.x = 0;
        this.onePoint.y = 0;
      },

      drawArea(e){
        let tmp = [...this.drawAreaPoints];
        tmp.push({x: e.offsetX, y: e.offsetY});
        this.drawAreaPoints = tmp;
        console.log(this.drawAreaPoints);
        this.drawArea2();
        if (this.drawAreaPoints.length > 2) {
          this.drawAreaDialogIsShow = true;
        }
      },

      drawArea2(){
        let tmp = [...this.drawAreaPoints];
        let array = [];
        for (let j = 0; j < tmp.length; j++) {
          array.push(tmp[j].x + ',' + tmp[j].y);
        }
        this.drawAreaPolygon = array.join(' ');
      },

      showDrawArea(){
        this.drawAreaIsShow = true;
      },

      showSetBaseStation(){
        this.setBaseStationIsShow = true;
        //console.log(Math.round((e.offsetX - this.shipImage.left) / this.scale));
        //console.log(Math.round((e.offsetY - this.shipImage.top) / this.scale));
      },

      hideSetBaseStation(e){
        this.setBaseStationIsShow = false;
      },

      setBaseStation(evt){
        console.log(this.setBaseStationPoints)
        console.log(evt.offsetX, evt.offsetY);
        let array = [...this.setBaseStationPoints];
        array.push({x: evt.offsetX, y: evt.offsetY});
        this.setBaseStationPoints = array;
        this.setBaseStationDialogIsShow = true;
        this.setBaseStation2();
      },

      setBaseStation2(){
        let array = [...this.setBaseStationPoints];
        let tmp = [];
        for (let i = 0; i < array.length - 1; i++) {
          tmp.push({x1: array[i].x, y1: array[i].y, x2: array[i + 1].x, y2: array[i + 1].y});
        }
        this.setBaseStationLigaturePoints = tmp;
        //if (this.setBaseStationPoints.length > 1) {
        //this.setBaseStationDialogIsShow = true;
        //}
      },

      setBaseStationPointEsc(){
        this.setBaseStationPoints = [];
        this.setBaseStationLigaturePoints = [];
        this.setBaseStationDialogIsShow = false;
      },

      setBaseStationPointComeOn(){
        this.setBaseStationDialogIsShow = false;
      },

      setBaseStationPointSubmit(){
        console.log(this.setBaseStationPoints);
        this.setBaseStationDialogIsShow = false;
        this.$emit('transmit', {
          id: this.shipMapData.data.id,
          points: this.setBaseStationPoints,
        });
      },

      showOSSvgLineAnimation(){
        this.svgLineIsShow = true;
        setTimeout(() => {
          this.$refs.svgline.lineAnimationStart();
        }, 10);
      },

      hideOSSvgLineAnimation(){
        if (!this.svgLineIsShow) {
          return;
        }
        setTimeout(() => {
          this.$refs.svgline.lineAnimationStop();
          this.svgLineIsShow = false;
        }, 10);
      },

      showTempSvgFromCanvas(){
        let tmpDeck = tool.getCookie('deck1');
        console.log(tmpDeck);
        if (tmpDeck) {
          this.svgPolygonPoints = [
            {name: '甲板1', type: 'polygon', points: JSON.parse(tmpDeck)},
          ];
          this.showOSSvg();
        }
      },

      showOSSvg(){
        this.osSvgIsShow = true;
      },

      hideOSSvg(){
        this.osSvgIsShow = false;
      },

      hideDSCanvas(){
        this.dsCanvasIsShow = false;
      },

      monitorMove(){
        let _this = this;
        document.ondblclick = null;
        let moveDiv = document.getElementById('moveDiv');
        let isDrag = false;
        let dx, dy, positionX, positionY;
        moveDiv.onmousedown = function (evt) {
          evt = evt || window.event;
          //console.log(evt);
          console.log(evt.offsetX, evt.offsetY);
          _this.movingFlag = true;
          isDrag = true;
          positionX = evt.clientX;
          positionY = evt.clientY;
          dx = moveDiv.offsetLeft;
          dy = moveDiv.offsetTop;
          document.onmousemove = function (evt) {
            evt = evt || window.event;
            _this.shipImage.left = dx + evt.clientX - positionX;
            _this.shipImage.top = dy + evt.clientY - positionY;
            return false;
          };
          document.onmouseup = function () {
            isDrag = false;
            _this.movingFlag = false;
            document.onmousemove = null;
            document.onmouseup = null;
          }
        }
      },

      setScaleAdd(){
        if (this.dsCanvasIsShow) {
          tool.message('设置甲板区域时，不能放大', 'error');
          return;
        }
        let scale = Math.round((this.scale + this.scaleStep) * 100) / 100;
        if (scale < 2) {
          this.scale = scale;
        } else {
          this.scale = 2;
          tool.message('不能再放大了！', 'warning');
        }
      },

      setScaleCut(){
        if (this.dsCanvasIsShow) {
          tool.message('设置甲板区域时，不能缩小', 'error');
          return;
        }
        let scale = Math.round((this.scale - this.scaleStep) * 100) / 100;
        if (scale > 0.1) {
          this.scale = scale;
        } else {
          this.scale = 0.1;
          tool.message('不能再缩小了！', 'warning');
        }
      },

      resetImageBecoming(){
        this.scale = 1;
        this.shipImage.left = 0;
        this.shipImage.top = 0;
        console.log(this.shipImage);
      },

      //地图100%显示
      setImageBecoming(){
        let widthScale2 = this.containerInfo.width / this.shipImage.width;
        let heightScale2 = this.containerInfo.height / this.shipImage.height;
        this.widthScale = Math.floor(widthScale2 * 100) / 100;
        this.heightScale = Math.floor(heightScale2 * 100) / 100;
        //this.scale = this.widthScale > this.heightScale ? this.heightScale : this.widthScale;
        //this.scale = Math.floor((this.widthScale + 0.01) * 100) / 100;
        this.scale = Math.floor((this.heightScale + 0.01) * 100) / 100;
        this.shipImage.left = 0;
        this.shipImage.top = 0;
        console.log(this.scale, widthScale2, heightScale2, this.widthScale, this.heightScale);
        console.log(this.shipImage);
      },

      getShipImageSize(){
        alert(this.shipImage.width + '|' + this.shipImage.height);
      },

      getMapSize(){
        let container = document.getElementById('map');
        this.containerInfo.width = container.clientWidth;
        this.containerInfo.height = container.clientHeight;
        console.log(this.containerInfo.width + '|' + this.containerInfo.height);
      },

      upload(){
        tool.setCookie('shipImage', '../common/images/ship2.jpg');
        this.getShipImage();
      },

      getShipImage(){
        this.shipImage.width = this.ship_img.width;
        this.shipImage.height = this.ship_img.height;
        this.shipImage.url = this.ship_img.url ? require('../common/images/ship2.jpg') : '';
        console.log(this.shipImage);
      }
    },

    components: {}
  }
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
  @import "../common/less/ship-map.less";
</style>
